import { render, staticRenderFns } from "./proxyIpRecord.vue?vue&type=template&id=4a599b49&scoped=true"
import script from "./proxyIpRecord.vue?vue&type=script&lang=js"
export * from "./proxyIpRecord.vue?vue&type=script&lang=js"
import style0 from "./proxyIpRecord.vue?vue&type=style&index=0&id=4a599b49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a599b49",
  null
  
)

export default component.exports